<script setup lang="ts">
const props = defineProps<{
  promo?: boolean
  root?: boolean
  colorful?: boolean
}>()
</script>
<template>
  <div
    class="flex-none justify-end hidden gap-2 lg:flex lg:col-span-2 items-center"
  >
    <UiButton
      :to="$utm.utmUrl('/login')"
      label="Masuk"
      variant="primaryOutline"
      class="lg:ring-0"
    />
    <UiButton
      v-if="!props.root"
      :to="$utm.utmUrlWithCustomMetaData('/kontak-kami')"
      label="Kontak Kami"
      class="shrink-0"
      variant="primaryOutline"
    />
    <UiButton
      :to="$utm.utmUrl()"
      label="Daftar Gratis"
      class="shrink-0 transition-all"
    />
  </div>
</template>
